import PropTypes from "prop-types";
import { CloseIcon } from "../ActionIcons";
import AreYouSureButton from "src/components/buttons/AreYouSureButton/AreYouSureButton";

export default function CloseDialogIcon({
  dataIsChanged = false,
  dontAskId = null,
  onNoClick = () => {},
  onClick = () => {},
  disableTabStop = false,
}) {
  const handleNoClick = async () => {
    onNoClick?.();
    return false;
  };

  const handleYesClick = async () => {
    await onClick();
    return true;
  };

  return (
    <div className="center">
      <AreYouSureButton
        disableTabStop={disableTabStop}
        onClick={handleYesClick}
        onCancel={handleNoClick}
        component="iconButton"
        componentProps={{
          "aria-label": "Tiedot ovat muuttuneet, poistu tallentamatta",
        }}
        dialogProps={{
          title: "Tallentamattomia muutoksia",
          content: "Tiedot ovat muuttuneet, poistu tallentamatta?",
          cancelText: "PERUUTA",
          acceptText: "SULJE TALLENTAMATTA",
          ConfirmIcon: <CloseIcon color="warning" />,
        }}
        askAreYouSure={dataIsChanged}
        dontAskId={dontAskId}>
        <CloseIcon color="primary" />
      </AreYouSureButton>
    </div>
  );
}

CloseDialogIcon.propTypes = {
  onNoClick: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  dataIsChanged: PropTypes.bool,
  dontAskId: PropTypes.string,
  disableTabStop: PropTypes.bool,
};

/**
 * USAGE
 * 
  <CloseDialogIcon
    onClick={handleClick}
    dataIsChanged={dataIsChanged}
    dontAskId="CloseDialogIcon"
  />
 */
